enum DefaultApplicationStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export default DefaultApplicationStatus;
